var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detection-score",attrs:{"title":_vm.description}},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.detection.score.toFixed(1)))]),_vm._v(" "),_c('div',{staticClass:"detection-certainty",style:(_vm.certaintyStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }